import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import MobileComponent from './components/Mobile/MobileComponent';
import DesktopComponent from './components/Desktop/DesktopComponent';
import { WebSocketProvider } from './context/WebSocketContext';

import AuthService from './class/services/AuthService';
import UserService from './class/User/UserService';

import './i18n';

const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;

function App() {
  const isMobile = useMediaQuery({ query: '(max-width: 820px)' });
  const [isStylesLoaded, setIsStylesLoaded] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [def_lang, setDefLang] = useState('en');
  const [isLogged, setIsLogged] = useState(AuthService.isLogged());
  const [geoBlock, setGeoBlock] = useState([]);  
  const [isBlocked, setIsBlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkFirstVisit = async () => {
      // const firstVisit = AuthService.getCustom('firstVisit');

      try {
        // const response = await fetch(`${cmsUrl}api/get_config`);
        // const data = await response.json();

        // if (data.status) {
          const currentLang = AuthService.getCustom('lang');
          const currentCurrency = AuthService.getCustom('currency');
          const currentSportLink = AuthService.getCustom('live_link');
          const currentSiteUrl = AuthService.getCustom('site_url');

          if (!currentLang) {
            AuthService.setCustom('lang', "en");
            setDefLang("en");
          }

          if (!currentCurrency) { 
            AuthService.setCustom('currency', "EUR");
          }

          if (!currentSportLink) {
            AuthService.setCustom('live_link', "https://bet4magic.xframe.live/");
          }

          if (!currentSiteUrl) {
            AuthService.setCustom('site_url', "https://1x2play.com/");
          }

          AuthService.setCustom('firstVisit', 'false');
        // }
      } catch (error) {
        console.error('Error fetching config:', error);
      }
    };

    checkFirstVisit();

    const customLink = document.createElement('link');
    customLink.rel = 'stylesheet';
    customLink.type = 'text/css';
    customLink.onload = () => setIsStylesLoaded(true);
    customLink.onerror = () => setIsStylesLoaded(true);
    customLink.href = isMobile ? '/css/custom_mobile.css' : '/css/custom_desktop.css';
    document.head.appendChild(customLink);

    const checkAuth = async () => {
      const token = AuthService.getCustom('auth_token');
      if (token) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    };

    checkAuth();

    const fetchGeoBlock = async () => {
      try {
        // const response = await UserService.getGeoBlock();  
        // if (response.status && response.data === 'Your country is blocked.') {
        //   setIsBlocked(true);  
        // }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error('Error fetching geo block:', error);
      }
    };

    fetchGeoBlock();


    return () => {
      document.head.removeChild(customLink);
    };
  }, [isMobile]);


  if (!isStylesLoaded || isLoading) {
    return (
      <div className='loaderContainer' style={styles.loaderContainer}>
        <img className='loaderImage' style={styles.loaderImage} src={`/assets/img/logo-mobile.png?ts=${new Date().getTime()}`} alt="Nome-sito" />
        <div className='loader' style={styles.loader}></div>
      </div>
    );
  }

  if (isBlocked) {
    return (
      <div className="blocked-message" style={styles.blockedMessage}>
        <img className='loaderImage'  style={styles.loaderImage} src={`/assets/img/logo-mobile.png?ts=${new Date().getTime()}`} alt="Nome-sito" />
        <h2>Your country is blocked.</h2>
        <p>You might be using a VPN.</p>
      </div>
    );
  }

  return (
    <WebSocketProvider>

    <div className="App">
      {isMobile ? (
        <MobileComponent isLogged={isLogged} setIsLogged={setIsLogged} def_lang={def_lang} />
      ) : (
        <DesktopComponent setIsLogged={setIsLogged} isLogged={isLogged} def_lang={def_lang} />
      )}
      </div>
      </WebSocketProvider>
  );
}

const styles = {
  loaderContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column', 
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ddd',
    zIndex: 9999,
  },
  loader: {
    width: '50px',
    height: '50px',
    border: '5px solid #f3f3f3',
    borderTop: '5px solid #b3122f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loaderImage: {
    width: '120px',
    marginBottom: '10px',
    marginLeft: '5px',
  },
  blockedMessage: {
    backgroundColor: 'rgb(255 255 255 / 90%)',
    textAlign: 'center',
    padding: '50px',
    color: 'rgb(51, 51, 51)',
    fontSize: '18px',
    height: '100%',
    position: 'absolute',
    padding: '0px',
    top: '0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default App;
